export default {
  open: false,

  stuck: false,

  scrollDir: null,

  init() {
    this.setHeaderHeight();

    this.watchScrollDirection();

    const nav = document.querySelector('[x-ref="nav"]');

    if (nav) {
      const firstLevelItems = nav.querySelectorAll(
        'nav.wp-block-navigation .wp-block-navigation-submenu__toggle'
      );

      // Mutation observer to handle when the aria-expanded attribute changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'aria-expanded'
          ) {
            const target: HTMLElement = mutation.target as HTMLElement;

            if (target.getAttribute('aria-expanded') === 'true') {
              nav.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            }
          }
        });
      });

      firstLevelItems.forEach((item) => {
        observer.observe(item, {
          attributes: true
        });
      });
    }
  },

  watchScrollDirection() {
    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', () => {
      let curScrollY = window.scrollY;

      if (lastScrollY < curScrollY) {
        this.scrollDir = 'down';
      } else if (lastScrollY > curScrollY) {
        this.scrollDir = 'up';
      } else {
        this.scrollDir = null;
      }

      lastScrollY = curScrollY;
    });
  },

  setHeaderHeight() {
    document.body.style.setProperty(
      '--header-height',
      getComputedStyle(document.querySelector('#site-header')).height
    );
  },

  toggleNav() {
    this.open = !this.open;
  }
};
